import { all, call, put, take } from "redux-saga/effects";
import { subscriptionPreferencesAT } from "../../subscriptionPreferences/SubscriptionPreferencesModel";
import { IUmSpAuthState } from "../auth/AuthModel";
import { showErrorOnSubscriptionPreferencesAction } from "../../subscriptionPreferences/subscriptionPreferencesActions";
import { fetchSaga, TApiResult } from "../_services/apiCalls";
import { userManagementApiEndpoints } from "../_services/endpoints";
import { loadDynamicContentAT } from "./LoadDynamicContentModel";

export function* loadDynamicContentSaga() {
    let action;
    while ((action = yield take([subscriptionPreferencesAT.hasUser]))) {
        const authInfo: IUmSpAuthState = action.authInfo;
        yield call(loadDynamicContent, authInfo?.userRecordInfo?.customerId);
    }
}

export function* loadDynamicContent(customerId: number) {
    //TODO

    // if (!Number.isFinite(customerId)) {
    //     yield put(
    //         showErrorOnSubscriptionPreferencesAction(
    //             "auth has no customerId",
    //             true
    //         )
    //     );
    //     return;
    // }

    yield all([
        call(loadCustomerConfig, customerId),
        call(loadCustomerInfo, customerId),
    ]);
}

function* loadCustomerConfig(customerId: number) {
    const [isSuccess, config]: TApiResult = yield call(
        fetchSaga,
        userManagementApiEndpoints.customerConfig(customerId)
    );

    if (!isSuccess) {
        yield put(
            showErrorOnSubscriptionPreferencesAction(
                "internal error: has no customer config\n" + config.message,
                true
            )
        );
    } else {
        yield put({ type: loadDynamicContentAT.hasCustomerConfig, config });
    }
}

function* loadCustomerInfo(customerId: number) {
    const [isSuccess, info]: TApiResult = yield call(
        fetchSaga,
        userManagementApiEndpoints.publicCustomers(customerId)
    );

    if (!isSuccess) {
        yield put(
            showErrorOnSubscriptionPreferencesAction(
                "internal error: has no customer info\n" + info.message,
                true
            )
        );
    } else {
        yield put({ type: loadDynamicContentAT.hasCustomerInfo, info });
    }
}
